import ls from '../../utils/localStorage.js';
import { getInfos,getInfoDetail } from '../../api/api';

const state = {
  info_list: '',
  info_detail: ''
}

const mutations = {
    UPDATE_INFO_LIST(state,payload) {
        state.info_list = JSON.parse(payload);
    },
    UPDATE_INFO_DETAIL(state,payload) {
        state.info_detail = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 列表
    requestInfos(store,item) {
        getInfos(item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_INFO_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    },

    // 详情
    requestInfoDetail(store,item) {
        getInfoDetail(item.id).then( data => {
            store.commit('UPDATE_INFO_DETAIL',JSON.stringify(data));
        }).catch(error => {
            
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
